import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {HelixSeriesListResultVo} from '../../common/shared/api/nicolas/vo/HelixSeriesListResultVo.interface';

export type GetHelixSeriesListParams = {
  mapUid: number;
};

/**
 * Helix 시리즈 목록 조회
 *
 * Origin: pageNicolasApi.getHelixSeriesList
 * API: GET /api/v1/helix/series/list
 */
export async function getHelixSeriesList(
  {mapUid}: GetHelixSeriesListParams,
  options?: FetcherOptions
): Promise<ApiResultVo & {result: HelixSeriesListResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/helix/series/list',
    {
      method: 'GET',
      params: {
        map_uid: mapUid,
      },
    },
    options
  );
  return response.data;
}
